<template>
  <div class="commonDialogBody">
    <PrintDialog @dialogV="dialog" ref="PrintDialog"/>
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
    <el-form-item label="区域">
         <el-select  clearable v-model="value" @change="classificationChange(value)" placeholder="请选择区域">
                    <el-option
                    v-for="item in classificationList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
    </el-form-item>
    <el-form-item label="所属项目">
       <el-select  clearable v-model="Itemvalue" @change="AffiliationChange(Itemvalue)" placeholder="请选择所属项目">
                    <el-option
                    v-for="item in Affiliation"
                    :key="item.projectId"
                    :label="item.projectName"
                    :value="item.projectId">
                    </el-option>
                </el-select>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PrintDialog from './PrintDialog.vue'
import QRCode from 'qrcodejs2' 
export default {
 components: {PrintDialog},
  name: "BulkPrintDialog",
  data() {
    return {
        dialogVisible: false,

        innerVisible:false,


        title:"标题",
        labelPosition:'right',
        formLabelAlign:{},

        classificationList:[],
        value:"",
        Itemvalue:"",
        Affiliation:[],

        PTlist:[],
        PTramark:[],
    };
  },
  methods: {

    modification(){
        this.$refs.PrintDialog.innerVisible = true;
        this.$refs.PrintDialog.PTlist=this.PTlist
    },
    classificationChange(res){
      for(let val of this.classificationList){
        if(res ==val.id){
     this.$http.get("/inspect/project/getProject?orgId="+res).then((res)=>{
      if(res.data.code == 200){
        let data = res.data.data
        this.Affiliation = data
      }else{
         this.$message.error(data.msg)
      }
      }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
     })
        }
      }
    },
    AffiliationChange(res){
      this.$http.get("/inspect/spot/getStation?projectId="+res).then((res)=>{
      if(res.data.code == 200){
        let data = res.data.data
        this.PTlist = data
      }else{
         this.$message.error(data.msg)
      }
      }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
     })
    },    
    qrcodeimg(text){
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: text, // 需要转换为二维码的内容
          width: 105,
          height: 105,
          colorDark: "#8bc34a",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
          src:"../../assets/images/logo.png"
        });
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    dialog(data){

    }

  },
  updated() {

  },

}
</script>

<style scoped lang="scss">
		.content{
			border: 1px solid #000;
			margin:0 auto;
			page-break-after:always;
      background: #fff;
		}
    .qrcode{
      margin-top: 2px;
      margin-left: 2px;
    }
</style>